import AgGridWrapper from '@/app/common/components/ag-grid/AgGridWrapper';

import { useSearchParams } from 'react-router-dom';
import { useGetOutLinksMutation } from '@/app/Crawl/api/detailsApi';
import {
  domain_linkColumn,
  link_3xx_destinationColumn,
  link_alt_imgColumn,
  link_hrefColumn,
  link_href_fragmentColumn,
  link_href_protocolColumn,
  link_href_queryColumn,
  link_href_query_countColumn,
  link_is_alternateColumn,
  link_is_authorColumn,
  link_is_bookmarkColumn,
  link_is_imgColumn,
  link_is_licenseColumn,
  link_is_nofollowColumn,
  link_is_noopenerColumn,
  link_is_noreferrerColumn,
  link_is_publisherColumn,
  link_is_sponsoredColumn,
  link_is_tagColumn,
  link_is_ugcColumn,
  link_src_imgColumn,
  link_textColumn,
  link_text_badColumn,
  ps_url_depthColumn
} from '../../../config/columns';
import { useGetUserInfoQuery } from '@/app/common/api/authApi';
import FiltersComponent from '@/app/common/components/filters/FiltersComponent';
import { Col, Row } from 'react-bootstrap';
import { decoder } from '@/helpers/utils';
import useDomain from '@/hooks/useDomain';

// تب لینک های داخلی جزییات صفحه
const OutlinkInternal = () => {
  const [searchParams] = useSearchParams();
  const { domain_slug } = useDomain();
  useGetUserInfoQuery();

  const [getOutlinks] = useGetOutLinksMutation(
    {
      job_page: searchParams.get('job_page')
    } as never
  );
  // ستون های جدول
  const columns = [
    link_hrefColumn({
      type: 'internal',
      details: 'internal',
      activeTab: 'overview'
    }),
    link_textColumn,
    domain_linkColumn,
    link_href_fragmentColumn,
    link_href_queryColumn,
    link_href_query_countColumn,
    link_href_protocolColumn,
    ps_url_depthColumn,
    link_text_badColumn,
    link_is_nofollowColumn,
    link_is_noopenerColumn,
    link_is_noreferrerColumn,
    link_is_alternateColumn,
    link_is_ugcColumn,
    link_is_tagColumn,
    link_is_sponsoredColumn,
    link_is_publisherColumn,
    link_is_licenseColumn,
    link_is_authorColumn,
    link_is_bookmarkColumn,
    link_is_imgColumn,
    link_alt_imgColumn,
    link_src_imgColumn({
      // issues: 'images_without_alt',
      details: 'assets_all',
      activeTab: 'assets_all',
      type: 'image'
    }),
    link_3xx_destinationColumn
  ];

  return (
    <Row className="mt-5">
      <Col md={12}>
        <FiltersComponent
          columns={columns}
          preQueries={searchParams.toString()}
        />
      </Col>
      <Col md={12}>
        <AgGridWrapper
          fetchFunction={getOutlinks}
          height="746px"
          columns={columns}
          additionalData={{
            job_page: searchParams.get('job_page'),
            domain_slug,
            type: 'internal',
            page_url: decoder(searchParams.get('page_url') as string)
          }}
          page_depth={2}
           
        />
      </Col>
    </Row>
  );
};

export default OutlinkInternal;
